import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getPrecertificacion: ["payload"],
  getPrecertificacionLoading: null,
  getPrecertificacionSuccess: ["getPrecertificacionData"],
  getPrecertificacionFailure: ["getPrecertificacionError"],

  confirmarPrecertificacion: ["payload"],
  confirmarPrecertificacionLoading: null,
  confirmarPrecertificacionSuccess: ["confirmarPrecertificacionData"],
  confirmarPrecertificacionFailure: ["confirmarPrecertificacionError"],

  cancelarPrecertificacion: ["payload"],
  cancelarPrecertificacionLoading: null,
  cancelarPrecertificacionSuccess: ["cancelarPrecertificacionData"],
  cancelarPrecertificacionFailure: ["cancelarPrecertificacionError"],

  getAutorizacionMadreData: ["payload"],
  getAutorizacionMadreDataLoading: null,
  getAutorizacionMadreDataSuccess: ["getAutorizacionMadreData"],
  getAutorizacionMadreDataFailure: ["getAutorizacionMadreDataError"],
});

export { Types };

export default Creators;